import { createSlice } from '@reduxjs/toolkit';
import { HomeMyViewInitialState } from './homeMyViewInitialState';

const homeMyViewSlice = createSlice({
  name: 'homeMyView',
  initialState: HomeMyViewInitialState,
  reducers: {
    //reset home my view slice
    resetHMVStore: (state) => {
      return {
        ...HomeMyViewInitialState,
      };
    },
    setEcosystemOptions: (state, action) => {
      state.ecosystemOptions = action.payload;
    },
    setProductOptions: (state, action) => {
      state.productOptions = action.payload;
    },
    setAllProductOptions: (state, action) => {
      state.allProductOptions = action.payload;
    },
    setSquadOptions: (state, action) => {
      state.squadOptions = action.payload;
    },
    setTimePeriodOptions: (state, action) => {
      state.timePeriodOptions = action.payload;
    },
    setTimePeriods: (state, action) => {
      state.timePeriod = action.payload;
    },
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedAccount = action.payload;
    },
    setSelectedEcosystem: (state, action) => {
      state.selectedEcosystem = action.payload;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
    setSelectedSquad: (state, action) => {
      state.selectedSquad = action.payload;
    },
    setMarketingFilters: (state, action) => {
      state.marketingFilters = action.payload;
    },
    setChannelFilter: (state, action) => {
      state.marketingFilters.Channel = action.payload;
    },
    setDiscussionTopicFilter: (state, action) => {
      state.marketingFilters.DiscussionTopic = action.payload;
    },
    setStakeholderTypeFilter: (state, action) => {
      state.marketingFilters.PayerStakeholderType = action.payload;
    },
    setTemplateNameFilter: (state, action) => {
      state.marketingFilters.TemplateName = action.payload;
    },
    setSurveyTypeFilter: (state, action) => {
      state.marketingFilters.SurveyType = action.payload;
    },
    setPresentationNameFilter: (state, action) => {
      state.marketingFilters.PresentationName = action.payload;
    },
    setKeyMessageFilter: (state, action) => {
      state.marketingFilters.KeyMessage = action.payload;
    },
    setSelectedTimePeriod: (state, action) => {
      state.selectedTimePeriod = action.payload;
    },
    setFocusAccountChecked: (state, action) => {
      state.focusAccountChecked = action.payload;
    },
    setIsAccountAvailable: (state, action) => {
      state.isAccountAvailable = action.payload;
    },
    setViewName: (state, action) => {
      state.viewName = action.payload;
    },
    setKpiId: (state, action) => {
      state.kpiId = action.payload;
    },
    setKpiName: (state, action) => {
      state.kpiName = action.payload;
    },
    setDimensionName: (state, action) => {
      state.dimensionName = action.payload;
    },
    setChartData: (state, action) => {
      state.chartData = action.payload;
    },
    setChartType: (state, action) => {
      state.chartType = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    setCards: (state, action) => {
      state.cards = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setImpactedCards: (state, action) => {
      state.impactedCards = action.payload;
    },
    setDefaultCard: (state, action) => {
      state.defaultCards = action.payload;
    },
    setTimespan: (state, action) => {
      state.timespan = action.payload;
    },
    setSelectedKPI: (state, action) => {
      state.selectedKPI = action.payload;
    },
    setNoDimensionValue: (state, action) => {
      state.noDimensionValue = action.payload;
    },
    setBenchmarkNoDimensionValue: (state, action) => {
      state.benchmarkNoDimensionValue = action.payload;
    },
    setSelectedKpiName: (state, action) => {
      state.selectedKpiName = action.payload;
    },
    setShowSuccess: (state, action) => {
      state.showSuccess = action.payload;
    },
    setShowWarningGlobal: (state, action) => {
      state.showWarning = action.payload;
    },
    setAdvanceButtonStatus: (state, action) => {
      state.advanceButtonValue = action.payload;
    },
    setAdvanceOptions: (state, action) => {
      state.advanceOptions = action.payload;
    },
    setAdvanceDropdownOptions: (state, action) => {
      state.advanceDropdownOptions = action.payload;
    },
    setSystemAlertsData: (state, action) => {
      state.systemAlertsData = action.payload;
    },
    setNotificationssData: (state, action) => {
      state.notificationsData = action.payload;
    },
    setWhatsNewDatas: (state, action) => {
      state.whatsNewData = action.payload;
    },
    setAllMView: (state, action) => {
      state.allMViews = action.payload;
    },
    setAllDView: (state, action) => {
      state.allDViews = action.payload;
    },
    setSelectedView: (state, action) => {
      state.selectedView = action.payload;
    },
  },
});

export const {
  setEcosystemOptions,
  setTimePeriodOption,
  setSelectedAccount,
  setSelectedCustomer,
  setSelectedEcosystem,
  setSelectedProduct,
  setSelectedTimePeriod,
  setFocusAccountChecked,
  setIsAccountAvailable,
  setViewName,
  setKpiId,
  setKpiName,
  setDimensionName,
  setChartType,
  setChartData,
  setTableData,
  setCards,
  setActiveTab,
  setImpactedCards,
  setDefaultCard,
  setSelectedSquad,
  setSquadOptions,
  setProductOptions,
  setAllProductOptions,
  setTimePeriods,
  setTimePeriodOptions,
  setSelectedKpiName,
  setSelectedKPI,
  setNoDimensionValue,
  setBenchmarkNoDimensionValue,
  setShowSuccess,
  setSelectedAppId,
  setTimespan,
  setKeyMessageFilter,
  setPresentationNameFilter,
  setSurveyTypeFilter,
  setTemplateNameFilter,
  setStakeholderTypeFilter,
  setDiscussionTopicFilter,
  setChannelFilter,
  setMarketingFilters,
  setAdvanceButtonStatus,
  setShowWarningGlobal,
  setAdvanceOptions,
  setAdvanceDropdownOptions,
  setSystemAlertsData,
  setNotificationssData,
  setWhatsNewDatas,
  resetHMVStore,
  setmyViewsList,
  setAllMView,
  setAllDView,
  setSelectedView,
} = homeMyViewSlice.actions;

export const homeMyViewSliceActions = homeMyViewSlice.actions;

export default homeMyViewSlice.reducer;
